import { useAuth } from "@/contexts/AuthProvider"
import { HandCoins, Home, Trophy } from "lucide-react"
import { NavLink } from "react-router-dom"

export function NavBar() {
    const { isAuthorized } = useAuth();

    return (
        <div className="bg-primary pt-2 h-16 w-screen fixed bottom-0 rounded-t-2xl md:hidden">
            <div className="flex gap-4 justify-around mx-4">
                <NavLink to="/" className={({ isActive }) => {
                    if (isActive) {
                        return "flex flex-col items-center font-bold text-buttondefault-foreground"
                    }

                    return "flex flex-col items-center text-buttondefault-foreground/90  hover:text-buttondefault-foreground"
                }}>
                    <Home />
                    Início
                </NavLink>
                <NavLink to="/compra/titulos" className={({ isActive }) => {
                    if (isActive) {
                        return "flex flex-col items-center font-bold text-buttondefault-foreground"
                    }

                    return "flex flex-col items-center text-buttondefault-foreground/90  hover:text-buttondefault-foreground"
                }}>
                    <HandCoins />
                    Comprar
                </NavLink>
                <NavLink to="/resultados" className={({ isActive }) => {
                    if (isActive) {
                        return "flex flex-col items-center font-bold text-buttondefault-foreground"
                    }

                    return "flex flex-col items-center text-buttondefault-foreground/90 hover:text-buttondefault-foreground"
                }}>
                    <Trophy />
                    Resultados
                </NavLink>
                {
                    isAuthorized && (
                        <NavLink to="/compra/creditos" className={({ isActive }) => {
                            if (isActive) {
                                return "flex flex-col items-center font-bold text-buttondefault-foreground"
                            }

                            return "flex flex-col items-center text-buttondefault-foreground/90 hover:text-buttondefault-foreground"
                        }}>
                            <Trophy />
                            Inserir Créditos
                        </NavLink>
                    )
                }
            </div>
        </div>
    )
}